var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "prediction-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "220",
                "is-append-query": true,
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                )
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", no: "look" },
                      on: {
                        click: function($event) {
                          return _vm.lookHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "new" },
                      on: {
                        click: function($event) {
                          return _vm.addHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.editBtnEnabled,
                        type: "success",
                        no: "edit"
                      },
                      on: {
                        click: function($event) {
                          return _vm.editHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "clone" },
                      on: {
                        click: function($event) {
                          return _vm.copyJobHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.deleteBtnEnabled,
                        type: "danger",
                        no: "delete"
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _vm.forecastApproval
                    ? [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.$checkPermission([
                                  "button_SIPREALERT_submit"
                                ]),
                                expression:
                                  "$checkPermission(['button_SIPREALERT_submit'])"
                              }
                            ],
                            attrs: { type: "primary", no: "submit" },
                            on: { click: _vm.submitHanlder }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.$checkPermission([
                                  "button_SIPREALERT_revoke"
                                ]),
                                expression:
                                  "$checkPermission(['button_SIPREALERT_revoke'])"
                              }
                            ],
                            attrs: { type: "primary", no: "withdraw" },
                            on: { click: _vm.revokeHanlder }
                          },
                          [_vm._v(_vm._s(_vm.$t("Message.Withdraw")))]
                        )
                      ]
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_SIPREALERT_accept"
                            ]) &&
                            _vm.useOrderCenterMode &&
                            _vm.approveCooperationBusiness,
                          expression:
                            "$checkPermission(['button_SIPREALERT_accept']) && useOrderCenterMode && approveCooperationBusiness"
                        }
                      ],
                      attrs: { type: "primary", no: "passAudit" },
                      on: {
                        click: function($event) {
                          return _vm.acceptHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_SIPREALERT_reject"
                            ]) &&
                            _vm.useOrderCenterMode &&
                            _vm.approveCooperationBusiness,
                          expression:
                            "$checkPermission(['button_SIPREALERT_reject']) && useOrderCenterMode && approveCooperationBusiness"
                        }
                      ],
                      attrs: { type: "primary", no: "approveRefuse" },
                      on: {
                        click: function($event) {
                          return _vm.rejectHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SIPREALERT_siReportTransfer"
                          ]),
                          expression:
                            "$checkPermission(['button_SIPREALERT_siReportTransfer'])"
                        }
                      ],
                      attrs: { type: "primary", no: "regularBusiness" },
                      on: {
                        click: function($event) {
                          return _vm.convertToRealJobHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.RegularBusiness")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      attrs: { type: "primary", no: "refuse" },
                      on: {
                        click: function($event) {
                          return _vm.rejectHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                  )
                ],
                2
              ),
              _c("div", { attrs: { slot: "other" }, slot: "other" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "12px",
                      "line-height": "12px",
                      color: "blue"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.OrangeWorkingDaysFromETA")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "12px",
                      "line-height": "12px",
                      color: "blue"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.RedWorkingDaysFromETA")))]
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "220000",
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-row-groups": _vm.dataListDragGroup,
                  "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery && _vm.filter.total > 0,
                    expression: "!appendQuery && filter.total>0"
                  }
                ],
                attrs: {
                  "config-module": "220000",
                  total: _vm.filter.total,
                  "page-count": _vm.filter.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQueryByPage
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.filter.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.rejectWindow.visible
        ? _c("reject-dialog", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }